import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useTheme } from 'styled-components';

export const CustomPageHeader = memo(
  ({
    title,
    subTitle,
    style,
  }: {
    title: string;
    subTitle?: string;
    style?: StyleProp<ViewStyle>;
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    return (
      <View style={style}>
        <Typography.Label medium size={rpx(30)} color={theme.colors.primary}>
          {title}
        </Typography.Label>
        <Typography.Label light>{subTitle}</Typography.Label>
      </View>
    );
  },
);
